const FeedDataSource = {
	'db': 0,
	'azure': 1,
	'onPage': 2
};

export default FeedDataSource;